import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/admin/auditoria',
    name: 'audit.index',
    component: () => import('./views/AuditIndex.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      requiresPermission: 'audit.read',
      breadcrumb: 'Auditoría',
    },
  },
]

export default routes
